import React from 'react'
import { FormattedMessage } from "react-intl";

const Detect = ({ setOpen }) => {
  return (
    // <div>
    // {sessionStorage.hasOwnProperty('modal') &&
    // <div style = {{textAlign:'center'}}>
    //   <FormattedMessage id="Please make sure to avoid using Google Translate and directly set the language settings through the doctor's portal" /><br/><br/>
    //   <button onClick = {() => setOpen(prevOpen => !prevOpen)} style = {{padding:"8px 16px",border:'none',background:"#663BB9",color:'#ffffff',borderRadius:"4px",cursor:'pointer'}}><FormattedMessage id = "Close"/></button>
    //   </div>
    // }
    // </div>
    <></>
  )
}

export default Detect;
